export const CATEGORIES = {
  need_discovery: "Need Discovery",
  objection_handling: "Objection Handling",
  closing: "Closing",
  retention: "Retention",
  cross_sell: "Cross-sell",
  rapport_building: "Rapport Building",
  other: "Other",
};

export const CATEGORY_COLORS = {
  need_discovery: "bg-blue-50 text-blue-600",
  objection_handling: "bg-orange-50 text-orange-600",
  closing: "bg-purple-50 text-purple-600",
  retention: "bg-teal-50 text-teal-600",
  cross_sell: "bg-pink-50 text-pink-600",
  rapport_building: "bg-green-50 text-green-600",
  other: "bg-slate-50 text-slate-500",
};
